import React, { useState, useEffect } from 'react';
import { 
  Wallet, TrendingUp, TrendingDown, PieChart, Target, 
  Plus, Calendar, Bell, Download, ChevronRight, X,
  Home, BarChart3, Settings,
  Edit2, Trash2, ArrowRightLeft, Check,
  User, LogOut, AlertCircle, RefreshCw,
  Search, Filter, Book
} from 'lucide-react';

// =============================================
// Helper: localStorage wrapper (pengganti window.storage)
// =============================================
const storage = {
  get: (key) => {
    try {
      const value = localStorage.getItem(key);
      return value ? { value } : null;
    } catch (e) {
      return null;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  },
  delete: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }
};

const AplikasiKeuanganPro = () => {
  const [activeTab, setActiveTab] = useState('beranda');
  const [transactions, setTransactions] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [goals, setGoals] = useState([]);
  const [wallets, setWallets] = useState([
    { id: 1, name: 'Kas', balance: 0, icon: '💵', color: '#10b981' },
    { id: 2, name: 'Bank', balance: 0, icon: '🏦', color: '#3b82f6' },
    { id: 3, name: 'E-Wallet', balance: 0, icon: '📱', color: '#8b5cf6' }
  ]);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const [showAddTransaction, setShowAddTransaction] = useState(false);
  const [showEditTransaction, setShowEditTransaction] = useState(false);
  const [showAddBudget, setShowAddBudget] = useState(false);
  const [showAddGoal, setShowAddGoal] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false);
  const [showGoalProgress, setShowGoalProgress] = useState(false);
  const [selectedGoalId, setSelectedGoalId] = useState(null);
  const [progressAmount, setProgressAmount] = useState('');
  
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [transactionType, setTransactionType] = useState('keluar');
  const [amount, setAmount] = useState('');
  const [category, setCategory] = useState('Makanan');
  const [selectedWallet, setSelectedWallet] = useState(1);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const [filterCategory, setFilterCategory] = useState('all');
  const [filterWallet, setFilterWallet] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilter, setShowFilter] = useState(false);

  const [budgetCategory, setBudgetCategory] = useState('Makanan');
  const [budgetAmount, setBudgetAmount] = useState('');
  const [budgetPeriod, setBudgetPeriod] = useState('monthly');

  const [goalName, setGoalName] = useState('');
  const [goalTarget, setGoalTarget] = useState('');
  const [goalCurrent, setGoalCurrent] = useState('0');
  const [goalDeadline, setGoalDeadline] = useState('');

  const [fromWallet, setFromWallet] = useState(1);
  const [toWallet, setToWallet] = useState(2);
  const [transferAmount, setTransferAmount] = useState('');
  const [transferNote, setTransferNote] = useState('');

  const categories = {
    keluar: [
      { name: 'Makanan', icon: '🍔', color: '#ef4444' },
      { name: 'Transport', icon: '🚗', color: '#f59e0b' },
      { name: 'Belanja', icon: '🛍️', color: '#ec4899' },
      { name: 'Hiburan', icon: '🎬', color: '#8b5cf6' },
      { name: 'Tagihan', icon: '📄', color: '#6b7280' },
      { name: 'Kesehatan', icon: '❤️', color: '#ef4444' },
      { name: 'Pendidikan', icon: '📚', color: '#3b82f6' },
      { name: 'Lainnya', icon: '💼', color: '#64748b' }
    ],
    masuk: [
      { name: 'Gaji', icon: '💰', color: '#10b981' },
      { name: 'Bonus', icon: '🎁', color: '#10b981' },
      { name: 'Investasi', icon: '📈', color: '#10b981' },
      { name: 'Lainnya', icon: '💵', color: '#10b981' }
    ]
  };

  useEffect(() => {
    loadData();
    checkAuth();
  }, []);

  const checkAuth = () => {
    try {
      const userData = storage.get('user');
      if (userData?.value) {
        const parsedUser = JSON.parse(userData.value);
        setUser(parsedUser);
        setIsAuthenticated(true);
      }
    } catch (e) {
      console.error('Auth check failed:', e);
    }
  };

  const handleGoogleLogin = () => {
    setLoading(true);
    try {
      const mockUser = {
        id: 'user_' + Date.now(),
        email: 'user@example.com',
        name: 'User Demo',
        photoURL: null
      };
      storage.set('user', JSON.stringify(mockUser));
      setUser(mockUser);
      setIsAuthenticated(true);
      showNotification('Login berhasil! 🎉', 'success');
    } catch (error) {
      showNotification('Login gagal. Coba lagi.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    storage.delete('user');
    setUser(null);
    setIsAuthenticated(false);
    showNotification('Logout berhasil', 'success');
  };

  const loadData = () => {
    try {
      const txData = storage.get('transactions');
      const walletData = storage.get('wallets');
      const budgetData = storage.get('budgets');
      const goalData = storage.get('goals');
      if (txData?.value) setTransactions(JSON.parse(txData.value));
      if (walletData?.value) setWallets(JSON.parse(walletData.value));
      if (budgetData?.value) setBudgets(JSON.parse(budgetData.value));
      if (goalData?.value) setGoals(JSON.parse(goalData.value));
    } catch (e) {
      console.error('Load data error:', e);
    }
  };

  const showNotification = (message, type = 'info') => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  const validateAmount = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return { valid: false, message: 'Jumlah harus berupa angka' };
    if (num <= 0) return { valid: false, message: 'Jumlah harus lebih dari 0' };
    if (num > 1000000000) return { valid: false, message: 'Jumlah terlalu besar' };
    return { valid: true };
  };

  const addTransaction = () => {
    const validation = validateAmount(amount);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }
    if (!category) { showNotification('Pilih kategori terlebih dahulu', 'error'); return; }

    if (transactionType === 'keluar') {
      const wallet = wallets.find(w => w.id === selectedWallet);
      if (wallet.balance < parseFloat(amount)) {
        showNotification('Saldo tidak mencukupi', 'error');
        return;
      }
    }

    setLoading(true);
    try {
      const newTransaction = {
        id: Date.now(),
        type: transactionType,
        amount: parseFloat(amount),
        category,
        walletId: selectedWallet,
        description,
        date: new Date().toISOString(),
        dateStr: new Date().toLocaleDateString('id-ID'),
        createdAt: Date.now()
      };

      const updatedWallets = wallets.map(w => {
        if (w.id === selectedWallet) {
          return { ...w, balance: transactionType === 'masuk' ? w.balance + parseFloat(amount) : w.balance - parseFloat(amount) };
        }
        return w;
      });

      const updatedTransactions = [newTransaction, ...transactions];
      setTransactions(updatedTransactions);
      setWallets(updatedWallets);
      storage.set('transactions', JSON.stringify(updatedTransactions));
      storage.set('wallets', JSON.stringify(updatedWallets));

      setAmount('');
      setDescription('');
      setShowAddTransaction(false);
      showNotification(`${transactionType === 'masuk' ? 'Pemasukan' : 'Pengeluaran'} berhasil ditambahkan! ✅`, 'success');
    } catch (error) {
      showNotification('Gagal menambahkan transaksi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const editTransaction = () => {
    if (!editingTransaction) return;
    const validation = validateAmount(amount);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }

    setLoading(true);
    try {
      const oldTx = transactions.find(t => t.id === editingTransaction.id);
      let updatedWallets = wallets.map(w => {
        if (w.id === oldTx.walletId) {
          return { ...w, balance: oldTx.type === 'masuk' ? w.balance - oldTx.amount : w.balance + oldTx.amount };
        }
        return w;
      });

      updatedWallets = updatedWallets.map(w => {
        if (w.id === selectedWallet) {
          return { ...w, balance: transactionType === 'masuk' ? w.balance + parseFloat(amount) : w.balance - parseFloat(amount) };
        }
        return w;
      });

      const updatedTransaction = { ...oldTx, type: transactionType, amount: parseFloat(amount), category, walletId: selectedWallet, description, updatedAt: Date.now() };
      const updatedTransactions = transactions.map(t => t.id === editingTransaction.id ? updatedTransaction : t);

      setTransactions(updatedTransactions);
      setWallets(updatedWallets);
      storage.set('transactions', JSON.stringify(updatedTransactions));
      storage.set('wallets', JSON.stringify(updatedWallets));

      setShowEditTransaction(false);
      setEditingTransaction(null);
      showNotification('Transaksi berhasil diubah! ✅', 'success');
    } catch (error) {
      showNotification('Gagal mengubah transaksi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const deleteTransaction = (transaction) => {
    if (!window.confirm('Yakin ingin menghapus transaksi ini?')) return;
    setLoading(true);
    try {
      const updatedWallets = wallets.map(w => {
        if (w.id === transaction.walletId) {
          return { ...w, balance: transaction.type === 'masuk' ? w.balance - transaction.amount : w.balance + transaction.amount };
        }
        return w;
      });

      const updatedTransactions = transactions.filter(t => t.id !== transaction.id);
      setTransactions(updatedTransactions);
      setWallets(updatedWallets);
      storage.set('transactions', JSON.stringify(updatedTransactions));
      storage.set('wallets', JSON.stringify(updatedWallets));
      showNotification('Transaksi berhasil dihapus! 🗑️', 'success');
    } catch (error) {
      showNotification('Gagal menghapus transaksi', 'error');
    } finally {
      setLoading(false);
    }
  };

  const openEditTransaction = (transaction) => {
    setEditingTransaction(transaction);
    setTransactionType(transaction.type);
    setAmount(transaction.amount.toString());
    setCategory(transaction.category);
    setSelectedWallet(transaction.walletId);
    setDescription(transaction.description || '');
    setShowEditTransaction(true);
  };

  const addBudget = () => {
    const validation = validateAmount(budgetAmount);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }
    setLoading(true);
    try {
      const newBudget = { id: Date.now(), category: budgetCategory, amount: parseFloat(budgetAmount), period: budgetPeriod, spent: 0, createdAt: Date.now() };
      const updatedBudgets = [...budgets, newBudget];
      setBudgets(updatedBudgets);
      storage.set('budgets', JSON.stringify(updatedBudgets));
      setBudgetAmount('');
      setShowAddBudget(false);
      showNotification('Budget berhasil ditambahkan! 💰', 'success');
    } catch (error) {
      showNotification('Gagal menambahkan budget', 'error');
    } finally {
      setLoading(false);
    }
  };

  const deleteBudget = (budgetId) => {
    if (!window.confirm('Yakin ingin menghapus budget ini?')) return;
    const updatedBudgets = budgets.filter(b => b.id !== budgetId);
    setBudgets(updatedBudgets);
    storage.set('budgets', JSON.stringify(updatedBudgets));
    showNotification('Budget berhasil dihapus!', 'success');
  };

  const addGoal = () => {
    if (!goalName || !goalTarget) { showNotification('Nama dan target harus diisi', 'error'); return; }
    const validation = validateAmount(goalTarget);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }
    setLoading(true);
    try {
      const newGoal = { id: Date.now(), name: goalName, target: parseFloat(goalTarget), current: parseFloat(goalCurrent) || 0, deadline: goalDeadline, createdAt: Date.now() };
      const updatedGoals = [...goals, newGoal];
      setGoals(updatedGoals);
      storage.set('goals', JSON.stringify(updatedGoals));
      setGoalName(''); setGoalTarget(''); setGoalCurrent('0'); setGoalDeadline('');
      setShowAddGoal(false);
      showNotification('Target berhasil ditambahkan! 🎯', 'success');
    } catch (error) {
      showNotification('Gagal menambahkan target', 'error');
    } finally {
      setLoading(false);
    }
  };

  const updateGoalProgress = (goalId, addAmount) => {
    const updatedGoals = goals.map(g => g.id === goalId ? { ...g, current: g.current + parseFloat(addAmount) } : g);
    setGoals(updatedGoals);
    storage.set('goals', JSON.stringify(updatedGoals));
    showNotification('Progress berhasil diperbarui!', 'success');
  };

  const deleteGoal = (goalId) => {
    if (!window.confirm('Yakin ingin menghapus target ini?')) return;
    const updatedGoals = goals.filter(g => g.id !== goalId);
    setGoals(updatedGoals);
    storage.set('goals', JSON.stringify(updatedGoals));
    showNotification('Target berhasil dihapus!', 'success');
  };

  const handleProgressSubmit = () => {
    const validation = validateAmount(progressAmount);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }
    updateGoalProgress(selectedGoalId, progressAmount);
    setProgressAmount('');
    setShowGoalProgress(false);
    setSelectedGoalId(null);
  };

  const transferBetweenWallets = () => {
    if (fromWallet === toWallet) { showNotification('Pilih dompet yang berbeda', 'error'); return; }
    const validation = validateAmount(transferAmount);
    if (!validation.valid) { showNotification(validation.message, 'error'); return; }
    const sourceWallet = wallets.find(w => w.id === fromWallet);
    if (sourceWallet.balance < parseFloat(transferAmount)) { showNotification('Saldo tidak mencukupi', 'error'); return; }

    setLoading(true);
    try {
      const updatedWallets = wallets.map(w => {
        if (w.id === fromWallet) return { ...w, balance: w.balance - parseFloat(transferAmount) };
        if (w.id === toWallet) return { ...w, balance: w.balance + parseFloat(transferAmount) };
        return w;
      });
      setWallets(updatedWallets);
      storage.set('wallets', JSON.stringify(updatedWallets));

      const sourceWalletName = wallets.find(w => w.id === fromWallet)?.name;
      const targetWalletName = wallets.find(w => w.id === toWallet)?.name;
      const transferTx = {
        id: Date.now(), type: 'transfer', amount: parseFloat(transferAmount), category: 'Transfer',
        walletId: fromWallet, toWalletId: toWallet,
        description: transferNote || `Transfer dari ${sourceWalletName} ke ${targetWalletName}`,
        date: new Date().toISOString(), dateStr: new Date().toLocaleDateString('id-ID'), createdAt: Date.now()
      };

      const updatedTransactions = [transferTx, ...transactions];
      setTransactions(updatedTransactions);
      storage.set('transactions', JSON.stringify(updatedTransactions));

      setTransferAmount(''); setTransferNote(''); setShowTransfer(false);
      showNotification('Transfer berhasil! 💸', 'success');
    } catch (error) {
      showNotification('Transfer gagal', 'error');
    } finally {
      setLoading(false);
    }
  };

  const getCurrentMonthYear = () => {
    const now = new Date();
    return { month: now.getMonth(), year: now.getFullYear() };
  };

  const thisMonthTransactions = transactions.filter(t => {
    const txDate = new Date(t.date);
    const current = getCurrentMonthYear();
    return txDate.getMonth() === current.month && txDate.getFullYear() === current.year;
  });

  const totalIncome = thisMonthTransactions.filter(t => t.type === 'masuk').reduce((sum, t) => sum + t.amount, 0);
  const totalExpense = thisMonthTransactions.filter(t => t.type === 'keluar').reduce((sum, t) => sum + t.amount, 0);
  const totalBalance = wallets.reduce((sum, w) => sum + w.balance, 0);

  const expenseByCategory = thisMonthTransactions.filter(t => t.type === 'keluar').reduce((acc, t) => {
    acc[t.category] = (acc[t.category] || 0) + t.amount;
    return acc;
  }, {});

  useEffect(() => {
    if (budgets.length === 0) return;
    const updatedBudgets = budgets.map(budget => {
      const spent = thisMonthTransactions.filter(t => t.type === 'keluar' && t.category === budget.category).reduce((sum, t) => sum + t.amount, 0);
      return { ...budget, spent };
    });
    const hasChanged = updatedBudgets.some((b, i) => b.spent !== budgets[i]?.spent);
    if (hasChanged) setBudgets(updatedBudgets);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactions]);

  const categoryColors = {
    'Makanan': '#ef4444', 'Transport': '#f59e0b', 'Belanja': '#ec4899',
    'Hiburan': '#8b5cf6', 'Tagihan': '#6b7280', 'Kesehatan': '#ef4444',
    'Pendidikan': '#3b82f6', 'Lainnya': '#64748b'
  };

  const formatCurrency = (num) => {
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}jt`;
    if (num >= 1000) return `${(num / 1000).toFixed(0)}rb`;
    return num.toFixed(0);
  };

  const filteredTransactions = transactions.filter(tx => {
    const matchCategory = filterCategory === 'all' || tx.category === filterCategory;
    const matchWallet = filterWallet === 'all' || tx.walletId === parseInt(filterWallet);
    const matchSearch = !searchQuery || tx.description?.toLowerCase().includes(searchQuery.toLowerCase()) || tx.category.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchWallet && matchSearch;
  });

  // ===========================
  // LOGIN SCREEN
  // ===========================
  if (!isAuthenticated) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #ec4899 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap');
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
        `}</style>

        <div style={{ background: 'white', borderRadius: '24px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)', padding: '32px', maxWidth: '400px', width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', width: '80px', height: '80px', borderRadius: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', boxShadow: '0 8px 20px rgba(102,126,234,0.4)' }}>
              <Wallet size={40} color="white" />
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: '800', color: '#1f2937', marginBottom: '8px' }}>
              Keuangan<span style={{ color: '#667eea' }}>Ku</span>
            </h1>
            <p style={{ color: '#6b7280' }}>Kelola keuangan dengan mudah dan cerdas</p>
          </div>

          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            style={{ width: '100%', background: 'white', border: '2px solid #e5e7eb', color: '#374151', fontWeight: '600', padding: '16px 24px', borderRadius: '12px', cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', opacity: loading ? 0.5 : 1, fontSize: '16px' }}
          >
            {loading ? (
              <RefreshCw size={24} style={{ animation: 'spin 1s linear infinite' }} />
            ) : (
              <>
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span>Masuk dengan Google</span>
              </>
            )}
          </button>

          <div style={{ marginTop: '24px', textAlign: 'center', fontSize: '13px', color: '#9ca3af' }}>
            Dengan masuk, Anda menyetujui <span style={{ color: '#667eea' }}>Syarat & Ketentuan</span> kami
          </div>
        </div>
        <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // ===========================
  // MAIN APP
  // ===========================
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
        .card { background: white; border-radius: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); }
        .gradient-primary { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
        .gradient-green { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
        .gradient-red { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); }
        .btn { border: none; border-radius: 14px; padding: 14px 28px; font-weight: 600; cursor: pointer; transition: all 0.2s; font-family: 'Poppins', sans-serif; font-size: 16px; }
        .btn-primary { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; }
        .btn-primary:active { transform: scale(0.98); }
        .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
        .input { width: 100%; padding: 16px; border: 2px solid #e5e7eb; border-radius: 14px; font-size: 16px; transition: border 0.2s; font-family: 'Poppins', sans-serif; background: white; }
        .input:focus { outline: none; border-color: #667eea; }
        .modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: flex-end; z-index: 1000; animation: fadeIn 0.2s; }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        .modal-content { background: white; border-radius: 28px 28px 0 0; width: 100%; max-height: 90vh; overflow-y: auto; animation: slideUp 0.3s; }
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
        .category-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
        .notification { position: fixed; top: 20px; right: 20px; left: 20px; padding: 16px 24px; border-radius: 12px; color: white; font-weight: 600; z-index: 2000; animation: slideInRight 0.3s; box-shadow: 0 4px 20px rgba(0,0,0,0.15); text-align: center; }
        @keyframes slideInRight { from { transform: translateY(-50px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
        .notification.success { background: linear-gradient(135deg, #10b981 0%, #059669 100%); }
        .notification.error { background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); }
        .notification.info { background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      `}</style>

      {notification && <div className={`notification ${notification.type}`}>{notification.message}</div>}

      {/* Header */}
      <div className="gradient-primary text-white p-6 pb-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <User size={20} />
            </div>
            <div>
              <p className="text-sm opacity-90">Halo,</p>
              <p className="font-bold">{user?.name || 'User'}</p>
            </div>
          </div>
          <button className="p-2 hover:bg-white/20 rounded-full transition">
            <Bell size={24} />
          </button>
        </div>

        <div className="text-center mb-6">
          <p className="text-purple-100 text-sm mb-1">Total Saldo</p>
          <p className="text-4xl font-bold mb-4">Rp {totalBalance.toLocaleString('id-ID')}</p>
          
          <div className="flex gap-3 justify-center">
            <div className="bg-white/20 backdrop-blur rounded-2xl px-6 py-3 flex-1 max-w-[160px]">
              <div className="flex items-center gap-2 mb-1"><TrendingUp size={16} /><span className="text-xs">Pemasukan</span></div>
              <p className="font-bold">Rp {formatCurrency(totalIncome)}</p>
            </div>
            <div className="bg-white/20 backdrop-blur rounded-2xl px-6 py-3 flex-1 max-w-[160px]">
              <div className="flex items-center gap-2 mb-1"><TrendingDown size={16} /><span className="text-xs">Pengeluaran</span></div>
              <p className="font-bold">Rp {formatCurrency(totalExpense)}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 -mt-4">
        {/* BERANDA */}
        {activeTab === 'beranda' && (
          <div className="space-y-4">
            <div className="card p-4">
              <div className="flex items-center justify-between mb-3">
                <h2 className="font-bold text-gray-800 text-lg">Dompet Saya</h2>
                <button onClick={() => setShowTransfer(true)} className="text-purple-600 text-sm font-semibold flex items-center gap-1">
                  <ArrowRightLeft size={16} />Transfer
                </button>
              </div>
              <div className="space-y-2">
                {wallets.map(wallet => (
                  <div key={wallet.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl" style={{ backgroundColor: wallet.color + '20' }}>{wallet.icon}</div>
                      <div>
                        <p className="font-semibold text-gray-800">{wallet.name}</p>
                        <p className="text-sm text-gray-500">Rp {wallet.balance.toLocaleString('id-ID')}</p>
                      </div>
                    </div>
                    <ChevronRight size={20} className="text-gray-400" />
                  </div>
                ))}
              </div>
            </div>

            {budgets.length > 0 ? (
              <div className="card p-4">
                <div className="flex items-center justify-between mb-3">
                  <h2 className="font-bold text-gray-800 text-lg">Budget Bulan Ini</h2>
                  <button onClick={() => setShowAddBudget(true)} className="text-purple-600 text-sm font-semibold">+ Tambah</button>
                </div>
                <div className="space-y-3">
                  {budgets.map(budget => {
                    const percentage = (budget.spent / budget.amount) * 100;
                    const isOverBudget = percentage > 100;
                    const isWarning = percentage > 80 && !isOverBudget;
                    return (
                      <div key={budget.id} className="bg-gray-50 p-3 rounded-xl">
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <span className="text-lg">{categories.keluar.find(c => c.name === budget.category)?.icon}</span>
                            <span className="font-semibold text-gray-800">{budget.category}</span>
                          </div>
                          <button onClick={() => deleteBudget(budget.id)} className="text-red-500 p-1 hover:bg-red-50 rounded-lg"><Trash2 size={16} /></button>
                        </div>
                        <div className="flex justify-between text-sm mb-2">
                          <span className="text-gray-600">Rp {budget.spent.toLocaleString('id-ID')} / Rp {budget.amount.toLocaleString('id-ID')}</span>
                          <span className={`font-bold ${isOverBudget ? 'text-red-600' : isWarning ? 'text-orange-600' : 'text-green-600'}`}>{percentage.toFixed(0)}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                          <div className={`h-2.5 rounded-full transition-all ${isOverBudget ? 'bg-red-500' : isWarning ? 'bg-orange-500' : 'bg-green-500'}`} style={{ width: `${Math.min(percentage, 100)}%` }} />
                        </div>
                        {isOverBudget && <p className="text-xs text-red-600 mt-2 flex items-center gap-1"><AlertCircle size={12} />Over budget Rp {(budget.spent - budget.amount).toLocaleString('id-ID')}</p>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="card p-6 text-center">
                <Target size={48} className="text-gray-300 mx-auto mb-3" />
                <p className="text-gray-600 mb-3">Belum ada budget</p>
                <button onClick={() => setShowAddBudget(true)} className="btn btn-primary text-sm">+ Tambah Budget</button>
              </div>
            )}

            {goals.length > 0 ? (
              <div className="card p-4">
                <div className="flex items-center justify-between mb-3">
                  <h2 className="font-bold text-gray-800 text-lg">Target Keuangan</h2>
                  <button onClick={() => setShowAddGoal(true)} className="text-purple-600 text-sm font-semibold">+ Tambah</button>
                </div>
                <div className="space-y-3">
                  {goals.map(goal => {
                    const percentage = (goal.current / goal.target) * 100;
                    const remaining = goal.target - goal.current;
                    return (
                      <div key={goal.id} className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl">
                        <div className="flex items-start justify-between mb-2">
                          <div className="flex-1">
                            <h3 className="font-bold text-gray-800 mb-1">{goal.name}</h3>
                            {goal.deadline && <p className="text-xs text-gray-500 flex items-center gap-1"><Calendar size={12} />Target: {new Date(goal.deadline).toLocaleDateString('id-ID')}</p>}
                          </div>
                          <button onClick={() => deleteGoal(goal.id)} className="text-red-500 p-1 hover:bg-red-100 rounded-lg"><Trash2 size={16} /></button>
                        </div>
                        <div className="flex justify-between text-sm mb-2">
                          <span className="text-gray-600">Rp {goal.current.toLocaleString('id-ID')} / Rp {goal.target.toLocaleString('id-ID')}</span>
                          <span className="font-bold text-purple-600">{percentage.toFixed(0)}%</span>
                        </div>
                        <div className="w-full bg-purple-200 rounded-full h-3 mb-3">
                          <div className="bg-gradient-to-r from-purple-500 to-pink-500 h-3 rounded-full transition-all" style={{ width: `${Math.min(percentage, 100)}%` }} />
                        </div>
                        <button
                          onClick={() => { setSelectedGoalId(goal.id); setProgressAmount(''); setShowGoalProgress(true); }}
                          className="w-full bg-purple-600 text-white text-sm py-2 px-4 rounded-lg hover:bg-purple-700 transition font-semibold"
                        >+ Tambah Progress</button>
                        {percentage < 100 ? (
                          <p className="text-xs text-gray-600 mt-2">Kurang Rp {remaining.toLocaleString('id-ID')} lagi</p>
                        ) : (
                          <p className="text-xs text-green-600 mt-2 flex items-center gap-1 font-semibold"><Check size={12} />Target tercapai! 🎉</p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="card p-6 text-center">
                <Target size={48} className="text-gray-300 mx-auto mb-3" />
                <p className="text-gray-600 mb-3">Belum ada target</p>
                <button onClick={() => setShowAddGoal(true)} className="btn btn-primary text-sm">+ Buat Target</button>
              </div>
            )}

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-3 text-lg">Pengeluaran Bulan Ini</h2>
              {Object.keys(expenseByCategory).length === 0 ? (
                <p className="text-center text-gray-400 py-8">Belum ada pengeluaran</p>
              ) : (
                <div className="space-y-3">
                  {Object.entries(expenseByCategory).sort(([,a],[,b]) => b - a).map(([cat, amt]) => {
                    const percentage = (amt / totalExpense) * 100;
                    return (
                      <div key={cat}>
                        <div className="flex items-center justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-lg" style={{ backgroundColor: (categoryColors[cat] || '#64748b') + '20' }}>
                              {categories.keluar.find(c => c.name === cat)?.icon}
                            </div>
                            <span className="font-medium text-gray-800">{cat}</span>
                          </div>
                          <span className="font-bold text-gray-800">Rp {formatCurrency(amt)}</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div className="h-2 rounded-full transition-all" style={{ width: `${percentage}%`, backgroundColor: categoryColors[cat] || '#64748b' }} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="card p-4">
              <div className="flex items-center justify-between mb-3">
                <h2 className="font-bold text-gray-800 text-lg">Transaksi Terakhir</h2>
                <button onClick={() => setActiveTab('transaksi')} className="text-purple-600 text-sm font-semibold">Lihat Semua</button>
              </div>
              {transactions.length === 0 ? (
                <p className="text-center text-gray-400 py-8">Belum ada transaksi</p>
              ) : (
                <div className="space-y-2">
                  {transactions.slice(0, 5).map(tx => {
                    const wallet = wallets.find(w => w.id === tx.walletId);
                    const catInfo = categories[tx.type]?.find(c => c.name === tx.category);
                    return (
                      <div key={tx.id} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition">
                        <div className="flex items-center gap-3">
                          <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-xl" style={{ backgroundColor: (catInfo?.color || '#e5e7eb') + '20' }}>
                            {tx.type === 'transfer' ? '💸' : catInfo?.icon}
                          </div>
                          <div>
                            <p className="font-semibold text-gray-800">{tx.description || tx.category}</p>
                            <p className="text-xs text-gray-500">{tx.dateStr} • {wallet?.name}</p>
                          </div>
                        </div>
                        <p className={`font-bold ${tx.type === 'masuk' ? 'text-green-600' : tx.type === 'transfer' ? 'text-blue-600' : 'text-red-600'}`}>
                          {tx.type === 'masuk' ? '+' : tx.type === 'transfer' ? '↔' : '-'}Rp {tx.amount.toLocaleString('id-ID')}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* LAPORAN */}
        {activeTab === 'laporan' && (
          <div className="space-y-4">
            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-4 text-lg">Ringkasan Keuangan</h2>
              <div className="grid grid-cols-2 gap-3 mb-6">
                <div className="gradient-green text-white p-4 rounded-xl">
                  <p className="text-sm opacity-90 mb-1">Total Pemasukan</p>
                  <p className="text-2xl font-bold">Rp {formatCurrency(totalIncome)}</p>
                </div>
                <div className="gradient-red text-white p-4 rounded-xl">
                  <p className="text-sm opacity-90 mb-1">Total Pengeluaran</p>
                  <p className="text-2xl font-bold">Rp {formatCurrency(totalExpense)}</p>
                </div>
              </div>
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl">
                <div className="flex items-center justify-between">
                  <span className="text-gray-700 font-semibold">Selisih Bulan Ini</span>
                  <span className={`text-2xl font-bold ${(totalIncome - totalExpense) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {(totalIncome - totalExpense) >= 0 ? '+' : ''}Rp {formatCurrency(Math.abs(totalIncome - totalExpense))}
                  </span>
                </div>
              </div>
            </div>

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-4 text-lg">Grafik Kategori</h2>
              {Object.keys(expenseByCategory).length === 0 ? (
                <div className="text-center py-12">
                  <PieChart size={64} className="text-gray-300 mx-auto mb-4" />
                  <p className="text-gray-400">Belum ada data pengeluaran</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {Object.entries(expenseByCategory).sort(([,a],[,b]) => b - a).map(([cat, amt]) => {
                    const percentage = (amt / totalExpense) * 100;
                    return (
                      <div key={cat} className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: (categoryColors[cat] || '#64748b') + '20' }}>
                          {categories.keluar.find(c => c.name === cat)?.icon}
                        </div>
                        <div className="flex-1">
                          <div className="flex justify-between mb-1">
                            <span className="text-sm font-semibold text-gray-800">{cat}</span>
                            <div className="text-right">
                              <div className="text-sm font-bold text-gray-800">{percentage.toFixed(1)}%</div>
                              <div className="text-xs text-gray-500">Rp {formatCurrency(amt)}</div>
                            </div>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2.5">
                            <div className="h-2.5 rounded-full transition-all" style={{ width: `${percentage}%`, backgroundColor: categoryColors[cat] || '#64748b' }} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-4 text-lg">Tren 3 Bulan Terakhir</h2>
              <div className="text-center py-12">
                <BarChart3 size={64} className="text-gray-300 mx-auto mb-4" />
                <p className="text-gray-400">Fitur grafik akan hadir</p>
              </div>
            </div>
          </div>
        )}

        {/* TRANSAKSI */}
        {activeTab === 'transaksi' && (
          <div className="space-y-4">
            <div className="card p-4">
              <div className="flex gap-2 mb-3">
                <div className="flex-1 relative">
                  <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input type="text" placeholder="Cari transaksi..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:outline-none" />
                </div>
                <button onClick={() => setShowFilter(!showFilter)} className={`p-3 rounded-xl transition ${showFilter ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-600'}`}>
                  <Filter size={20} />
                </button>
              </div>

              {showFilter && (
                <div className="space-y-3 pt-3 border-t">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Kategori</label>
                    <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:outline-none">
                      <option value="all">Semua Kategori</option>
                      {[...categories.keluar, ...categories.masuk].map(cat => <option key={cat.name} value={cat.name}>{cat.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Dompet</label>
                    <select value={filterWallet} onChange={(e) => setFilterWallet(e.target.value)} className="w-full p-3 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:outline-none">
                      <option value="all">Semua Dompet</option>
                      {wallets.map(wallet => <option key={wallet.id} value={wallet.id}>{wallet.name}</option>)}
                    </select>
                  </div>
                  <button onClick={() => { setFilterCategory('all'); setFilterWallet('all'); setSearchQuery(''); }} className="w-full py-2 text-purple-600 font-semibold hover:bg-purple-50 rounded-xl transition">Reset Filter</button>
                </div>
              )}
            </div>

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-3 text-lg">Semua Transaksi ({filteredTransactions.length})</h2>
              {filteredTransactions.length === 0 ? (
                <div className="text-center py-12">
                  <Wallet size={64} className="text-gray-300 mx-auto mb-4" />
                  <p className="text-gray-400">{searchQuery || filterCategory !== 'all' || filterWallet !== 'all' ? 'Tidak ada transaksi yang cocok' : 'Belum ada transaksi'}</p>
                </div>
              ) : (
                <div className="space-y-2">
                  {filteredTransactions.map(tx => {
                    const wallet = wallets.find(w => w.id === tx.walletId);
                    const catInfo = categories[tx.type]?.find(c => c.name === tx.category);
                    return (
                      <div key={tx.id} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition group">
                        <div className="flex items-center gap-3 flex-1">
                          <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-xl" style={{ backgroundColor: (catInfo?.color || '#e5e7eb') + '20' }}>
                            {tx.type === 'transfer' ? '💸' : catInfo?.icon}
                          </div>
                          <div className="flex-1">
                            <p className="font-semibold text-gray-800">{tx.description || tx.category}</p>
                            <p className="text-xs text-gray-500">{tx.dateStr} • {wallet?.name}</p>
                          </div>
                        </div>
                        <div className="flex items-center gap-3">
                          <p className={`font-bold ${tx.type === 'masuk' ? 'text-green-600' : tx.type === 'transfer' ? 'text-blue-600' : 'text-red-600'}`}>
                            {tx.type === 'masuk' ? '+' : tx.type === 'transfer' ? '↔' : '-'}Rp {tx.amount.toLocaleString('id-ID')}
                          </p>
                          <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition">
                            <button onClick={() => openEditTransaction(tx)} className="p-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition"><Edit2 size={16} /></button>
                            <button onClick={() => deleteTransaction(tx)} className="p-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition"><Trash2 size={16} /></button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* PENGATURAN */}
        {activeTab === 'pengaturan' && (
          <div className="space-y-4">
            <div className="card p-6">
              <div className="flex items-center gap-4">
                <div className="w-20 h-20 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white text-3xl font-bold">
                  {user?.name?.charAt(0) || 'U'}
                </div>
                <div>
                  <h2 className="font-bold text-gray-800 text-xl">{user?.name || 'User'}</h2>
                  <p className="text-gray-600">{user?.email || 'user@example.com'}</p>
                </div>
              </div>
            </div>

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-3 text-lg">Akun</h2>
              <div className="space-y-2">
                {[{ icon: User, label: 'Edit Profil' }, { icon: Bell, label: 'Notifikasi' }, { icon: Download, label: 'Export Data' }].map(({ icon: Icon, label }) => (
                  <button key={label} className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition">
                    <div className="flex items-center gap-3"><Icon size={20} className="text-gray-600" /><span className="font-medium text-gray-800">{label}</span></div>
                    <ChevronRight size={20} className="text-gray-400" />
                  </button>
                ))}
              </div>
            </div>

            <div className="card p-4">
              <h2 className="font-bold text-gray-800 mb-3 text-lg">Lainnya</h2>
              <div className="space-y-2">
                {[{ icon: Book, label: 'Panduan' }, { icon: AlertCircle, label: 'Tentang' }].map(({ icon: Icon, label }) => (
                  <button key={label} className="w-full flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition">
                    <div className="flex items-center gap-3"><Icon size={20} className="text-gray-600" /><span className="font-medium text-gray-800">{label}</span></div>
                    <ChevronRight size={20} className="text-gray-400" />
                  </button>
                ))}
              </div>
            </div>

            <button onClick={handleLogout} className="w-full card p-4 flex items-center justify-center gap-2 text-red-600 font-bold hover:bg-red-50 transition">
              <LogOut size={20} />Keluar
            </button>
            <div className="text-center text-sm text-gray-500 py-4">KeuanganKu v1.0.0<br />© 2024 All Rights Reserved</div>
          </div>
        )}
      </div>

      {/* MODALS */}

      {/* Add Transaction */}
      {showAddTransaction && (
        <div className="modal" onClick={() => setShowAddTransaction(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Tambah Transaksi</h2>
                <button onClick={() => setShowAddTransaction(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="flex gap-2 mb-4">
                <button onClick={() => { setTransactionType('keluar'); setCategory('Makanan'); }} className={`flex-1 py-3 rounded-xl font-semibold transition ${transactionType === 'keluar' ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}>Pengeluaran</button>
                <button onClick={() => { setTransactionType('masuk'); setCategory('Gaji'); }} className={`flex-1 py-3 rounded-xl font-semibold transition ${transactionType === 'masuk' ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}>Pemasukan</button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah (Rp)</label>
                <input type="number" placeholder="0" value={amount} onChange={e => setAmount(e.target.value)} className="input text-2xl font-bold" />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Kategori</label>
                <div className="category-grid">
                  {categories[transactionType].map(cat => (
                    <button key={cat.name} onClick={() => setCategory(cat.name)} className={`p-3 rounded-xl text-center transition ${category === cat.name ? 'bg-purple-600 text-white shadow-lg' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                      <div className="text-2xl mb-1">{cat.icon}</div>
                      <div className="text-xs font-medium">{cat.name}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Dompet</label>
                <div className="grid grid-cols-3 gap-2">
                  {wallets.map(wallet => (
                    <button key={wallet.id} onClick={() => setSelectedWallet(wallet.id)} className={`p-3 rounded-xl text-center transition ${selectedWallet === wallet.id ? 'bg-purple-600 text-white shadow-lg' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                      <div className="text-xl mb-1">{wallet.icon}</div>
                      <div className="text-xs font-medium">{wallet.name}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Catatan (Opsional)</label>
                <input type="text" placeholder="Contoh: Makan siang di resto" value={description} onChange={e => setDescription(e.target.value)} className="input" />
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowAddTransaction(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={addTransaction} disabled={loading || !amount} className="flex-1 btn btn-primary">{loading ? 'Menyimpan...' : 'Simpan'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Transaction */}
      {showEditTransaction && editingTransaction && (
        <div className="modal" onClick={() => setShowEditTransaction(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Edit Transaksi</h2>
                <button onClick={() => setShowEditTransaction(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="flex gap-2 mb-4">
                <button onClick={() => { setTransactionType('keluar'); if (!categories.keluar.find(c => c.name === category)) setCategory('Makanan'); }} className={`flex-1 py-3 rounded-xl font-semibold transition ${transactionType === 'keluar' ? 'bg-red-500 text-white' : 'bg-gray-100 text-gray-600'}`}>Pengeluaran</button>
                <button onClick={() => { setTransactionType('masuk'); if (!categories.masuk.find(c => c.name === category)) setCategory('Gaji'); }} className={`flex-1 py-3 rounded-xl font-semibold transition ${transactionType === 'masuk' ? 'bg-green-500 text-white' : 'bg-gray-100 text-gray-600'}`}>Pemasukan</button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah (Rp)</label>
                <input type="number" placeholder="0" value={amount} onChange={e => setAmount(e.target.value)} className="input text-2xl font-bold" />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Kategori</label>
                <div className="category-grid">
                  {categories[transactionType].map(cat => (
                    <button key={cat.name} onClick={() => setCategory(cat.name)} className={`p-3 rounded-xl text-center transition ${category === cat.name ? 'bg-purple-600 text-white shadow-lg' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                      <div className="text-2xl mb-1">{cat.icon}</div>
                      <div className="text-xs font-medium">{cat.name}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Dompet</label>
                <div className="grid grid-cols-3 gap-2">
                  {wallets.map(wallet => (
                    <button key={wallet.id} onClick={() => setSelectedWallet(wallet.id)} className={`p-3 rounded-xl text-center transition ${selectedWallet === wallet.id ? 'bg-purple-600 text-white shadow-lg' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                      <div className="text-xl mb-1">{wallet.icon}</div>
                      <div className="text-xs font-medium">{wallet.name}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Catatan (Opsional)</label>
                <input type="text" placeholder="Contoh: Makan siang di resto" value={description} onChange={e => setDescription(e.target.value)} className="input" />
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowEditTransaction(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={editTransaction} disabled={loading || !amount} className="flex-1 btn btn-primary">{loading ? 'Menyimpan...' : 'Simpan'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Budget */}
      {showAddBudget && (
        <div className="modal" onClick={() => setShowAddBudget(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Tambah Budget</h2>
                <button onClick={() => setShowAddBudget(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Kategori</label>
                <select value={budgetCategory} onChange={e => setBudgetCategory(e.target.value)} className="input">
                  {categories.keluar.map(cat => <option key={cat.name} value={cat.name}>{cat.name}</option>)}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah Budget (Rp)</label>
                <input type="number" placeholder="0" value={budgetAmount} onChange={e => setBudgetAmount(e.target.value)} className="input text-2xl font-bold" />
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Periode</label>
                <select value={budgetPeriod} onChange={e => setBudgetPeriod(e.target.value)} className="input">
                  <option value="monthly">Bulanan</option>
                  <option value="weekly">Mingguan</option>
                </select>
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowAddBudget(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={addBudget} disabled={loading || !budgetAmount} className="flex-1 btn btn-primary">{loading ? 'Menyimpan...' : 'Simpan'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Goal */}
      {showAddGoal && (
        <div className="modal" onClick={() => setShowAddGoal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Tambah Target</h2>
                <button onClick={() => setShowAddGoal(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Nama Target</label>
                <input type="text" placeholder="Contoh: Beli Laptop" value={goalName} onChange={e => setGoalName(e.target.value)} className="input" />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah Target (Rp)</label>
                <input type="number" placeholder="0" value={goalTarget} onChange={e => setGoalTarget(e.target.value)} className="input text-2xl font-bold" />
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Terkumpul Saat Ini (Rp)</label>
                <input type="number" placeholder="0" value={goalCurrent} onChange={e => setGoalCurrent(e.target.value)} className="input" />
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Deadline (Opsional)</label>
                <input type="date" value={goalDeadline} onChange={e => setGoalDeadline(e.target.value)} className="input" />
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowAddGoal(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={addGoal} disabled={loading || !goalName || !goalTarget} className="flex-1 btn btn-primary">{loading ? 'Menyimpan...' : 'Simpan'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Goal Progress */}
      {showGoalProgress && (
        <div className="modal" onClick={() => setShowGoalProgress(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Tambah Progress</h2>
                <button onClick={() => setShowGoalProgress(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah Tambahan (Rp)</label>
                <input type="number" placeholder="0" value={progressAmount} onChange={e => setProgressAmount(e.target.value)} className="input text-2xl font-bold" autoFocus />
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowGoalProgress(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={handleProgressSubmit} disabled={!progressAmount} className="flex-1 btn btn-primary">Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Transfer */}
      {showTransfer && (
        <div className="modal" onClick={() => setShowTransfer(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold">Transfer Antar Dompet</h2>
                <button onClick={() => setShowTransfer(false)} className="p-2 hover:bg-gray-100 rounded-full transition"><X size={24} /></button>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Dari Dompet</label>
                <select value={fromWallet} onChange={e => setFromWallet(parseInt(e.target.value))} className="input">
                  {wallets.map(wallet => <option key={wallet.id} value={wallet.id}>{wallet.icon} {wallet.name} - Rp {wallet.balance.toLocaleString('id-ID')}</option>)}
                </select>
              </div>
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-purple-100 rounded-full"><ArrowRightLeft size={24} className="text-purple-600" /></div>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Ke Dompet</label>
                <select value={toWallet} onChange={e => setToWallet(parseInt(e.target.value))} className="input">
                  {wallets.map(wallet => <option key={wallet.id} value={wallet.id}>{wallet.icon} {wallet.name} - Rp {wallet.balance.toLocaleString('id-ID')}</option>)}
                </select>
              </div>
              <div className="mb-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Jumlah (Rp)</label>
                <input type="number" placeholder="0" value={transferAmount} onChange={e => setTransferAmount(e.target.value)} className="input text-2xl font-bold" />
              </div>
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">Catatan (Opsional)</label>
                <input type="text" placeholder="Contoh: Transfer untuk tabungan" value={transferNote} onChange={e => setTransferNote(e.target.value)} className="input" />
              </div>
              <div className="flex gap-3">
                <button onClick={() => setShowTransfer(false)} className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition">Batal</button>
                <button onClick={transferBetweenWallets} disabled={loading || !transferAmount || fromWallet === toWallet} className="flex-1 btn btn-primary">{loading ? 'Memproses...' : 'Transfer'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FAB */}
      <button
        onClick={() => setShowAddTransaction(true)}
        className="fixed bottom-24 right-6 w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-full shadow-2xl flex items-center justify-center hover:shadow-xl transition z-50 hover:scale-110"
      >
        <Plus size={32} strokeWidth={3} />
      </button>

      {/* Bottom Nav */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-6 py-3 z-40 shadow-lg">
        <div className="flex justify-around items-center max-w-lg mx-auto">
          {[
            { id: 'beranda', icon: Home, label: 'Beranda' },
            { id: 'laporan', icon: BarChart3, label: 'Laporan' },
            { id: 'transaksi', icon: Wallet, label: 'Transaksi' },
            { id: 'pengaturan', icon: Settings, label: 'Lainnya' }
          ].map(({ id, icon: Icon, label }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              className={`flex flex-col items-center gap-1 py-2 px-4 rounded-xl transition ${activeTab === id ? 'text-purple-600 bg-purple-50' : 'text-gray-500'}`}
            >
              <Icon size={24} strokeWidth={activeTab === id ? 2.5 : 2} />
              <span className={`text-xs font-medium ${activeTab === id ? 'font-bold' : ''}`}>{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AplikasiKeuanganPro;
